import React, { useEffect, useState } from 'react';

import { Link, useNavigate, useParams } from 'react-router-dom';

import Swal from 'sweetalert2';

import { FaQuestionCircle } from "react-icons/fa";

import Title from '../../Components/Admin/Title';

import useFetchApi from '../../hooks/useFetchApi';
import { FAQ_DATA_EDIT_ADMIN_URL, FAQ_DATA_UPDATE_ADMIN_URL } from '../../utils/Constant';

function EditFaq() {

    // =========================
    // ROUTE PARAM
    // =========================

    const { id } = useParams();

    const navigate = useNavigate();

    // =========================
    // FETCH FAQ
    // =========================

    const url = FAQ_DATA_EDIT_ADMIN_URL(id);

    // const {
    //     data,
    //     loading
    // } = useFetchApi({
    //     url,
    //     dataKey: null
    // });

    const { data, loading, error } = useFetchApi({
        url: url,
        dataKey: 'recentBookings',
        token: localStorage.getItem("admin_token"), // ✅ auth token
    });

    // =========================
    // FORM DATA
    // =========================

    const [formData, setFormData] = useState({
        question: '',
        answer: '',
        status: 1
    });

    // =========================
    // ERROR STATE
    // =========================

    const [errors, setErrors] = useState({});

    // =========================
    // SET DATA
    // =========================

    useEffect(() => {

        if (data?.id) {

            setFormData({
                question: data.question || '',
                answer: data.answer || '',
                status: data.status ?? 1,
            });
        }

    }, [data]);

    // =========================
    // VALIDATION
    // =========================

    const validateErrors = (name, value) => {

        let error = '';

        // required validation
        if (!value) {

            error = 'This field is required';
        }

        return error;
    };

    // =========================
    // HANDLE CHANGE
    // =========================

    const handleChange = (e) => {

        const { name, value } = e.target;

        const updatedData = {
            ...formData,
            [name]: value,
        };

        setFormData(updatedData);

        const error = validateErrors(name, value);

        setErrors((prev) => ({
            ...prev,
            [name]: error,
        }));
    };

    // =========================
    // FORM VALIDATE
    // =========================

    const formValidate = () => {

        const tempErrors = {};

        Object.keys(formData).forEach((key) => {

            const error = validateErrors(
                key,
                formData[key]
            );

            if (error) {

                tempErrors[key] = error;
            }
        });

        setErrors(tempErrors);

        return Object.keys(tempErrors).length === 0;
    };

    // =========================
    // UPDATE FAQ
    // =========================

    const handleSubmit = async (e) => {

        e.preventDefault();

        // =========================
        // FORM VALIDATION
        // =========================

        const isValid = formValidate();

        if (!isValid) return;

        try {

            const res = await fetch(
                FAQ_DATA_UPDATE_ADMIN_URL(id),
                {
                    method: 'PUT',

                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },

                    body: JSON.stringify(formData),
                }
            );

            const result = await res.json();

            if (!res.ok) {

                Swal.fire({
                    icon: 'error',
                    title: 'Oops!',
                    text: result.message || 'Update failed',
                });

                return;
            }

            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: result.message,
                timer: 2000,
                showConfirmButton: false,
            });

            setTimeout(() => {

                navigate('/admin/faq');

            }, 2000);

        } catch (error) {

            console.log(error);

            Swal.fire({
                icon: 'error',
                title: 'Server Error',
                text: 'Something went wrong',
            });
        }
    };

    // =========================
    // LOADING
    // =========================

    if (loading) {

        return (
            <div className="p-10 text-center">
                Loading...
            </div>
        );
    }

    return (
        <>

            <Title
                icon={FaQuestionCircle}
                title='Edit FAQ'
            />

            <div className="bg-white rounded shadow-lg mt-5">

                <h4 className="
                    text-lg
                    p-4
                    font-semibold
                    border-b
                    flex
                    justify-between
                    items-center
                ">

                    Edit FAQ

                    <Link
                        to="/admin/faq"
                        className="
                            btn
                            btn-accent
                            btn-sm
                            text-white
                            shadow-md
                        "
                    >
                        Back
                    </Link>

                </h4>

                <form
                    onSubmit={handleSubmit}
                    className="p-4"
                >

                    <div className="grid grid-cols-1 gap-5">

                        {/* Question */}
                        <div>

                            <label className="block text-sm mb-1">
                                Question
                            </label>

                            <input
                                type="text"
                                name="question"
                                value={formData.question}
                                onChange={handleChange}
                                className={`
                                    input
                                    input-bordered
                                    w-full
                                    ${errors.question ? 'border-error' : ''}
                                `}
                            />

                            {errors.question && (
                                <p className="text-red-500 text-xs mt-1">
                                    {errors.question}
                                </p>
                            )}

                        </div>

                        {/* Answer */}
                        <div>

                            <label className="block text-sm mb-1">
                                Answer
                            </label>

                            <textarea
                                name="answer"
                                value={formData.answer}
                                onChange={handleChange}
                                className={`
                                    textarea
                                    textarea-bordered
                                    w-full
                                    h-40
                                    ${errors.answer ? 'border-error' : ''}
                                `}
                            />

                            {errors.answer && (
                                <p className="text-red-500 text-xs mt-1">
                                    {errors.answer}
                                </p>
                            )}

                        </div>

                        {/* Status */}
                        <div>

                            <label className="block text-sm mb-1">
                                Status
                            </label>

                            <select
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                                className="
                                    select
                                    select-bordered
                                    w-full
                                "
                            >

                                <option value="1">
                                    Active
                                </option>

                                <option value="0">
                                    Inactive
                                </option>

                            </select>

                        </div>

                        {/* Button */}
                        <div>

                            <button
                                type="submit"
                                className="
                                    btn
                                    btn-primary
                                    text-white
                                "
                            >
                                Update FAQ
                            </button>

                        </div>

                    </div>

                </form>

            </div>

        </>
    );
}

export default EditFaq;